/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {Subject} from 'rxjs';
import {customRequiredValidation} from '@irian-ro/shared-components-module';
import { FormUtils } from "@irian-ro/util-forms";
import {ActionDefinitionDtoModel, ActionDefinitionMetaDataModel, SubscriptionTypeVoModel} from '@well/domain';

@Component({
  selector: 'well-action-inputs',
  templateUrl: './action-inputs.component.html',
  styleUrls: ['./action-inputs.component.scss']
})
export class ActionInputsComponent implements OnInit {

  today: Date = new Date();

  private subscriptionType: SubscriptionTypeVoModel | undefined = undefined;

  get action(): ActionDefinitionDtoModel | undefined {
    return this._action;
  }

  @Input() set action(action: ActionDefinitionDtoModel) {
    if (action) {
      this._action = action;
      this.updateFormValues(action);
      FormUtils.markAllAsTouched(this.form);
    }
  }

  @Input() meta: ActionDefinitionMetaDataModel | undefined = undefined;

  private _subscriptionTypeUuid: string | undefined = undefined;

  get subscriptionTypeUuid(): string | undefined {
    return this._subscriptionTypeUuid;
  }

  @Input() set subscriptionTypeUuid(value: string) {
    this._subscriptionTypeUuid = value;
    this.subscriptionType = new SubscriptionTypeVoModel();
    this.subscriptionType.uuid = this._subscriptionTypeUuid;
    this.subscriptionTypeControl.patchValue(this.subscriptionType);
  }

  @Output() save: Subject<ActionDefinitionDtoModel> = new Subject();
  private _action: ActionDefinitionDtoModel | undefined = undefined;

  form: FormGroup = this.formBuilder.group({
    uuid: [null],
    actionName: [null, [customRequiredValidation('actionName')]],
    deleted: [null],
    actionCost: [null, [customRequiredValidation('cost')]],
    validFrom: [null],
    validTo: [null],
    monthlyIncludedAmount: [null],
    allowExtra: [true],
    subscriptionTypeVo: this.formBuilder.group({
      moduleName: [null],
      startBalance: [null],
      typeName: [null],
      uuid: [null],
    })
  });

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.form.markAllAsTouched();
  }
  get nameFormControl() {
    return this.form.controls['actionName'] as FormControl;
  }

  get costFormControl() {
    return this.form.controls['actionCost'] as FormControl;
  }

  get validFromFormControl() {
    return this.form.controls['validFrom'] as FormControl;
  }

  get validToFormControl() {
    return this.form.controls['validTo'] as FormControl;
  }

  get subscriptionTypeControl() {
    return this.form.controls['subscriptionTypeVo'] as FormControl;
  }

  get validFromAsDate(){
    return new Date(this.validFromFormControl.value);
  }

  onSubmit() {
    FormUtils.markAllAsTouched(this.form);
    FormUtils.markAllAsDirty(this.form);
    this.form.updateValueAndValidity({emitEvent: true});

    if (this.form.valid) {
      this.save.next((<AbstractControl>this.form).getRawValue());
    }
  }

  private updateFormValues(actionDTOModel: ActionDefinitionDtoModel) {
    this.form.patchValue(actionDTOModel);
    if (actionDTOModel.allowExtra == null) {
      this.form.controls['allowExtra'].setValue(true);
    }
    this.form.updateValueAndValidity();
  }

}
